/**
 * Simple API Response Caching Utility
 * Using sessionStorage for per-session caching of static data like Categories and Services.
 */

const CACHE_PREFIX = "api_cache_";
const DEFAULT_EXPIRY = 3600 * 1000; // 1 hour

export const getCache = (key) => {
  try {
    const cached = sessionStorage.getItem(CACHE_PREFIX + key);
    if (!cached) return null;

    const { data, expiry } = JSON.parse(cached);
    if (Date.now() > expiry) {
      sessionStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }
    return data;
  } catch (e) {
    console.error("Cache read error:", e);
    return null;
  }
};

export const setCache = (key, data, expiryMs = DEFAULT_EXPIRY) => {
  try {
    const cacheData = {
      data,
      expiry: Date.now() + expiryMs,
    };
    sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify(cacheData));
  } catch (e) {
    console.warn("Cache write error (possibly storage full):", e);
  }
};

export const clearCache = (key) => {
  if (key) {
    sessionStorage.removeItem(CACHE_PREFIX + key);
  } else {
    Object.keys(sessionStorage).forEach((k) => {
      if (k.startsWith(CACHE_PREFIX)) {
        sessionStorage.removeItem(k);
      }
    });
  }
};
